import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIsFetching } from '../selectors';
import { fetchPpisRelatedToPpsi } from '../actions';

const usePpisRelatedToPpsi = ppsiId => {
  const [notStartedFetching, setNotStartedFetching] = useState(true);
  const dispatch = useDispatch();
  const isFetchingPpis = useSelector(getIsFetching);
  const isFetching = notStartedFetching ? true : isFetchingPpis;

  useEffect(() => {
    dispatch(fetchPpisRelatedToPpsi(ppsiId));
    setNotStartedFetching(false);
  }, [dispatch, ppsiId]);

  return [isFetching];
};

export default usePpisRelatedToPpsi;
